import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7177d50f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "banner"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
}, null, -1));
import { Swiper, SwiperSlide } from "swiper/vue";
import { Virtual, Pagination, Autoplay } from "swiper/modules";
import "@/assets/swiper-custom.css";
export default /*#__PURE__*/_defineComponent({
  __name: 'app-banner',
  setup(__props) {
    const modules = [Virtual, Pagination, Autoplay];
    const pagination = {
      el: ".swiper-pagination",
      clickable: true,
      bulletClass: "banner-swiper-pagination-bullet",
      bulletActiveClass: "banner-swiper-pagination-bullet-active",
      bulletElement: "span"
    };
    const bannerList = ["https://img2.qiuwenxinli.com/official-website/psychology-app/banner-1.jpg", "https://img2.qiuwenxinli.com/official-website/psychology-app/banner-2.jpg", "https://img2.qiuwenxinli.com/official-website/psychology-app/banner-3.jpg"];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Swiper), {
        modules: modules,
        loop: true,
        autoplay: {
          delay: 5000 //1秒切换一次
        },

        pagination: pagination,
        class: "banner-swiper"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(bannerList, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            class: "banner-swiper-item",
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              class: "banner-swiper-item-img",
              src: item
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1024);
        }), 64)), _hoisted_3]),
        _: 1
      })]);
    };
  }
});